<template>
    <div class="mt-3">
        <div class="flex flex-col gap-3 md:grid md:grid-cols-3 md:items-center">
            <div class="hidden md:block"></div>
            <h1 class="text-3xl text-center">
                Archivos encontrados
                <strong class="text-theme-primary">
                    {{ itemsNumber }}
                </strong>
            </h1>
            <div class="flex justify-center md:justify-end">
                <app-button
                    v-if="$ability.hasPermission('file:Create')"
                    color="success"
                    size="large"
                    @click="$router.push('/app/files/new')"
                >
                    <span class="hidden md:inline">Nuevo archivo</span>
                    <span class="md:hidden font-bold">+</span>
                </app-button>
            </div>
        </div>
        <div class="flex flex-wrap">
            <div class="flex justify-between flex-col lg:flex-row w-full">
                <div class="my-3 flex items-center rounded-full justify-around">
                    <custom-input
                        v-model="keyword"
                        type="text"
                        placeholder="Buscar .."
                        class="mr-2"
                        @click-icon="reloadItems"
                        @enter="reloadItems"
                    >
                        <template #icon> 🔎 </template>
                    </custom-input>
                    <app-button relief @click="reloadItems">
                        Consultar 🔎
                    </app-button>
                </div>

                <div class="my-3 flex items-center justify-around">
                    <custom-pagination
                        v-model="currentPage"
                        :length="pagesNumber"
                        @input="listItems()"
                    />
                </div>
            </div>
        </div>
        <div class="flex flex-wrap mb-5">
            <file-item
                v-for="item in itemsCurrent"
                :key="item.id"
                :file="item"
            />
            <div v-if="!itemsCurrent.length" class="w-11/12 mx-auto mt-4">
                <strong>
                    Nuestro sistema NO encuentra resultados. Intenta modificar
                    los filtros de búsqueda.
                </strong>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import CustomInput from "@/components/utils/CustomInput.vue";
import FileItem from "@/components/utils/FileItem.vue";

export default {
    name: "FilesIndex",
    components: { FileItem, CustomInput },
    layout: "app",
    meta: {
        roles: ["administrator", "support"]
    },
    data: () => ({
        itemsCurrent: [],

        currentPage: 1,
        pagesNumber: 0,
        itemsNumber: 0,
        backup: {
            items: [],
            pagination: { pagesNumber: 1, itemsNumber: 1 }
        },
        keyword: ""
    }),
    computed: {
        ...mapState("files", ["files"]),
        ...mapGetters("control", ["backgroundColor"])
    },
    watch: {
        keyword(value) {
            if (value) {
                this.itemsCurrent = this.files.filter((item) =>
                    item.alt.includes(value.toLowerCase())
                );
                this.itemsNumber = this.itemsCurrent.length;
                this.pagesNumber = 1;
                this.currentPage = 1;
            } else {
                this.itemsCurrent = [...this.backup.items];
                this.itemsNumber = Number(this.backup.pagination.itemsNumber);
                this.pagesNumber = Number(this.backup.pagination.pagesNumber);
            }
        }
    },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (!(await verifyPagePermission("file:List", "/app"))) return;
        this.listItems(true);
    },
    methods: {
        ...mapActions("files", ["listFilesPaginated"]),
        async listItems(complete = false) {
            this.isLoading = true;
            this.$loading.show();
            try {
                const { items, pagination } = await this.listFilesPaginated({
                    page: this.currentPage,
                    keyword: this.keyword,
                    complete
                });
                this.itemsCurrent = items;
                if (pagination) {
                    this.itemsNumber = pagination.itemsNumber;
                    this.pagesNumber = pagination.pagesNumber;
                }
                this.backup = {
                    items,
                    pagination: {
                        itemsNumber: Number(this.itemsNumber),
                        pagesNumber: Number(this.pagesNumber)
                    }
                };
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.isLoading = false;
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async reloadItems() {
            this.currentPage = 1;
            await this.listItems(true);
        }
    }
};
</script>
